import { render, staticRenderFns } from "./HomeDevelopBlock.vue?vue&type=template&id=2adfbe6e"
import script from "./HomeDevelopBlock.vue?vue&type=script&lang=js"
export * from "./HomeDevelopBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports